import { useState } from 'react';
import { RECENT_VISIBLE_LIMIT } from './constants';

export function useRecentExpansion<T>(items: T[] = []) {
  const [expanded, setExpanded] = useState(false);
  const safeItems = Array.isArray(items) ? items : [];
  const hiddenCount = Math.max(0, safeItems.length - RECENT_VISIBLE_LIMIT);
  const visible = expanded ? safeItems : safeItems.slice(0, RECENT_VISIBLE_LIMIT);
  return {
    visible,
    hiddenCount,
    expanded,
    toggle: () => setExpanded((e) => !e),
    canToggle: safeItems.length > RECENT_VISIBLE_LIMIT,
  };
}
